
const RowContent = ({className, children}) => {

    return <>
        <div className={`row py-2 py-md-2 py-lg-2 ${className ? className : ''}`}>{children ?? children}</div>
    </>
}

export default RowContent;